import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { useTranslation } from 'core/i18n';

export interface BulkActivateCustomAlarmsComponentProps {
    onClick: VoidFunction;
}

export const BulkActivateCustomAlarmsComponent: React.FC<BulkActivateCustomAlarmsComponentProps> = (props) => {
    const { onClick } = props;
    const { t } = useTranslation();

    return (
        <BulkActionButtonComponent
            onClick={onClick}
            text={t('settings.devices.custom-alarms.actions.activate')}
            iconName="circle_on_off"
        />
    );
};
